var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "active": _vm.isModalActive,
      "canCancel": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isModalActive = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('section', {
    staticClass: "modal-card-body has-text-centered"
  }, [_c('b', [_vm._v("LandmarksVue")]), _vm._v(" is a project using\n      "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Vue.js")]), _vm._v("\n      and\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/transcranial/keras-js",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Keras.js")]), _vm._v(" using a VGG16 convolutional neural network trained on ImageNet and fine-tuned on a landmark images dataset.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Source code available\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/vfaramond/landmarks_vue",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("here")]), _vm._v("!\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Victor Faramond | " + _vm._s((new Date()).getFullYear()))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/vfaramond",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "github"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/vfaramond",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "twitter"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/victorfaramond",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "linkedin"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:victor.faramond@gmail.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "envelope"
    }
  })], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c278470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoModal.vue
// module id = 9WKg
// module chunks = 1